import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";
import {get} from "lodash";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import {ResolvableComponent} from "@ispm/core/decorators/resolvable-component.decorator";
import {SummaryTableWebService} from "@ispm/dynamic-form/components/summary-table/summary-table.service";
import {throwError} from "rxjs";
import {Store} from "@ngrx/store";
import {IPCOSummaryTableArray} from "@ispm/dynamic-form/interfaces/ISummaryTableInterface";
import {SUMMARYTABLE_ACTIONS} from "@ispm/dynamic-form/components/summary-table/store/actions";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface"
import {AgregationService, BundleCall} from "@ispm-client/modules/aggregator/services";
import {take} from "rxjs/operators";
import {IdataBinding} from "@ispm-client/modules/aggregator/interfaces";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";


@Component({
    selector: 'gen-summary-table',
    templateUrl: './summary-table.component.html',
    styleUrls: ['./summary-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ResolvableComponent()
export class SummaryTableComponent implements OnInit, IWidgetItem, AfterViewInit, OnDestroy {

    constructor(private store: Store<IgenomicsState>,
                private _changeDetector: ChangeDetectorRef,
                private summaryService: SummaryTableWebService,
                private routerManagerService: RouterManagerService,
                private _agregationService: AgregationService,
                private _bundleCall: BundleCall) {
        this.currentPatientId = this.routerManagerService.parameters.patientId;
        this.store$ = store.select('pcoSummaryTable') as any;
    }
    public tableData: any;
    public formItems: any;
    public widgetPayload: any;
    public backendEndpoint: string;
    public httpMethod: string;
    public requestBody: any;
    public currentPatientId: any;
    public lesionsData: Array<any> = [];
    public store$: Store<IPCOSummaryTableArray>;

    set widgetConfig(widgetConfig: IdynamicFormItem) {
        this.formItems = widgetConfig.widgetPayload.forms;
        this.widgetPayload = widgetConfig.widgetPayload;
        this.backendEndpoint = get(this.widgetPayload.backendAPI, 'endpoint');
        this.httpMethod = get(this.widgetPayload.backendAPI, 'httpMethod');
        this.requestBody = get(this.widgetPayload.backendAPI, 'requestBody');
    }

    set widgetData(widgetData: any) {
        this._changeDetector.markForCheck();
        this._changeDetector.detectChanges();
    }

    ngOnInit() {
        const requestBody: Array<any> = get(this.widgetPayload.backendAPI, 'requestBody.actionItems');
        let requestBodyArray:IdataBinding;
        requestBody.forEach(value =>{
            requestBodyArray = {
                targetResource: (get(value, 'databinding.targetResource')),
                queryString : (get(value, 'databinding.queryString')),
                identifier : (get(value, 'databinding.identifier')),
                identifierType : (get(value, 'databinding.identifierType')),
                prefetch:(get(value, 'databinding.prefetch'))
            };
        });
        this._agregationService.getStoreItemObservable('pcoSummaryTable.summaryTableModel',requestBodyArray)
            .pipe(take(1))
            .subscribe(val => {
                if (val.summaryTableModel) {
                    this.lesionsData = val.summaryTableModel;
                    if (this.lesionsData.find(item => item.patientId && item.patientId !== this.routerManagerService.parameters.patientId)) {
                        this.store$.dispatch({
                          type: SUMMARYTABLE_ACTIONS.ADD_SUMMARY,
                          payload: null
                        });
                    }
                }
            });
        this.fetchData();
    }

    ngAfterViewInit(): void {
    }

    fetchData(): any {
        try {
            const requestBody: Array<any> = get(this.widgetPayload.backendAPI, 'requestBody.actionItems');
            let requestBodyArray:IdataBinding;
            requestBody.forEach(value =>{
                requestBodyArray = {
                    targetResource: (get(value, 'databinding.targetResource')),
                    queryString : (get(value, 'databinding.queryString')),
                    identifier : (get(value, 'databinding.identifier')),
                    identifierType : (get(value, 'databinding.identifierType')),
                    prefetch:(get(value, 'databinding.prefetch'))
                };
            });
            this._agregationService.getStoreItemObservable('pcoSummaryTable.summaryTableModel',requestBodyArray)
                .pipe(take(1))
                .subscribe(val =>{
                    if(val.summaryTableModel == null || val.summaryTableModel ==undefined){
                        this.requestBody['patientId'] = this.currentPatientId;
                        this.summaryService.getTableData(this.backendEndpoint, this.httpMethod, this.requestBody)
                            .pipe(take(1))
                            .subscribe(res => {
                                this.lesionsData = res;
                                this._changeDetector.detectChanges();
                                this._changeDetector.markForCheck();
                                this.store$.dispatch({
                                    type: SUMMARYTABLE_ACTIONS.ADD_SUMMARY,
                                    payload: res
                                });
                            });
                    }else{
                        this.lesionsData = val.summaryTableModel;
                        this._changeDetector.detectChanges();
                        this._changeDetector.markForCheck();
                    }
                });

        } catch (e) {
            return throwError(e);
        }
    }

    ngOnDestroy(): void {
        return this.store$.dispatch({
            type: SUMMARYTABLE_ACTIONS.RESET_SUMMARY,
        });
    }
}
